import React, { useEffect, useState, useRef, useMemo } from "react"
import { withRouter, Link } from "react-router-dom"
import { Card, CardBody, Col, Row, Button, UncontrolledTooltip } from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import Select from "react-select"
import {
  clearMessage,
  getAuditTicktes as onGetAuditTickets,
  resetExportFileData,
  getExportAuditTickets,
} from "../../store/audit/actions"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { AuditTypes } from "constants/common"
import { isEmpty, map } from "lodash"
import moment from "moment"
// Import scss
import "../../assets/scss/custom.scss"
//redux
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { messageTitle } from "constants/common";
import { convertUtcToLocal } from "helpers/util"

const sizePerPage = 25;
const defaultStartDate = moment().startOf("M")
const defaultEndDate = moment()
import { dateformat } from "config"
const { SearchBar } = Search

const AuditTicketList = props => {
  const dispatch = useDispatch()
  const [fileType, setFileType] = useState({ label: "PDF", value: "pdf" })
  const [auditType, setAuditType] = useState({
    value: AuditTypes[0].value,
    label: AuditTypes[0].title,
  });
  const [startDate, setStartDate] = useState(
    defaultStartDate.format(dateformat.default)
  )
  const [endDate, setEndDate] = useState(
    defaultEndDate.format(dateformat.default)
  )
  const [currentPage, setCurrentPage] = useState(1);
  const { auditTicketList, file, message, pagination, error } = useSelector(
    state => ({
      auditTicketList: state.auditTicket.auditTicketList,
      pagination: state.auditTicket.pagination,
      message: state.auditTicket.message,
      error: state.auditTicket.error,
      file: state.auditTicket.file,
    })
  );
  const [searchKey, setSearchKey] = useState("");
  const [filteredRes, setFilteredRes] = useState([]);

  useEffect(() => {
    if (auditTicketList) {
      setFilteredRes(auditTicketList);
    }
  }, [auditTicketList]);

  useEffect(() => {
    if (searchKey.length >= 2 || searchKey == "") {
      setCurrentPage(1);
      dispatch(onGetAuditTickets({ module: auditType.value, page: currentPage, size: sizePerPage, search: searchKey, startDate: startDate, endDate: endDate, }));
    }
    // if(searchKey !== ""){
    //   const regex = new RegExp(searchKey.toLowerCase(), 'g');
    //   let filteredList = auditTicketList?.filter((el)=>{
    //     if(regex.test(el?.audtiTicketId.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.audtiModuleCode.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.actionType.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.approvalDetails.toLowerCase())){
    //       return el;
    //     }
    //   });
    //   setFilteredRes(filteredList);
    // }else{
    //   setFilteredRes(auditTicketList);
    // }
  }, [searchKey]);

  const auditModuleLabel = (moduleType) => {
    let labelValue = "User ID";
    switch (moduleType) {
      case "user": labelValue = "User ID"
        break;
      case "carpark": labelValue = "Carpark ID"
        break;
      case "guest": labelValue = "Guest ID"
        break;
      case "role": labelValue = "Role ID";
        break;
      case "season": labelValue = "Season ID";
        break;
      case "admin": labelValue = "Admin ID";
        break;
      default: labelValue = "ID";
        break;
    }
    return labelValue;
  }

  const spListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      formatter: record => <>{record._id}</>,
    },
    {
      text: "Operator",
      dataField: "createdBy",
      sort: true,
    },
    {
      text: "DateTime",
      dataField: "appliedDateTime",
      sort: true,
      formatter: (cellContent, record) => (
        <>
          {record && moment(record.appliedDateTime).format("Do MMM YYYY, h:mm a")}
        </>
      ),
    },    
    {
      text: "Type",
      dataField: "auditModuleType",
      sort: true,
    },
    {
      text: "Object ID",
      dataField: "audtiModuleCode",
      sort: true,
      formatter: (cellContent, record) => (
        <div className="d-flex gap-3">
        <div id={"moduleCode"+record?._id}>
          {record?.audtiModuleCode}
        </div>
        {record?.audtiModuleName?(
        <UncontrolledTooltip placement="bottom" target={"moduleCode"+record?._id} innerClassName="bg-info">
          {record?.audtiModuleName}
        </UncontrolledTooltip>):null
        }
        </div>
      ),

    },
    {
      text: "Action",
      dataField: "actionType",
      sort: true,
    },
    {
      text: "Affected Field(s)",
      dataField: "affectedFields",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <div style={{ whiteSpace: "normal", width: 300 }}>
            {(record?.affectedFields || "")
              .replace(/^,+|,+$/g, "")
              .replaceAll("null", "--")}
          </div>
        )
      },
    },
    {
      text: "Old Values",
      dataField: "fromChanges",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <div style={{ whiteSpace: "normal", width: 300 }}>
            {(record?.fromChanges || "").replace(/^,+|,+$/g, "").replaceAll("null", "--")}
          </div>
        )
      },
    },
    {
      text: "Values Changed",
      dataField: "toChanges",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <div style={{ whiteSpace: "normal", width: 300 }}>
            {(record?.toChanges || "")
              .replace(/^,+|,+$/g, "")
              .replaceAll(",,", ",")
              .replaceAll(`[object Object]`, "")
              .replaceAll("null", "--")}
          </div>
        )
      },
    },
    {
      text: "Audit ID",
      dataField: "audtiTicketId",
      sort: true,
    },
  ]
  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  useEffect(() => {
    //dispatch(onGetAuditTickets({ module: auditType.value, page: currentPage, size: sizePerPage, search: searchKey }));
    // return function cleanup() {
    //   dispatch(resetData())
    // }
    if (file) {
      handleExport(file)
      setTimeout(() => {
        dispatch(resetExportFileData())
      }, 300)
    }
  }, [file]);

  useEffect(() => {
    dispatch(onGetAuditTickets({ module: auditType.value, page: currentPage, size: sizePerPage, search: searchKey, startDate: startDate, endDate: endDate, }));
  }, [currentPage]);

  useMemo(() => {
    if (message) {
      message == "PDF file content not found." ||
        message == "Failed to export invalid file type."
        ? toastr.error(message, messageTitle)
        : toastr.success(message, messageTitle)
      dispatch(onGetAuditTickets({ module: auditType.value, page: currentPage, size: sizePerPage, search: searchKey, startDate: startDate, endDate: endDate, }));
      setTimeout(() => {
        // resetForm()
        dispatch(clearMessage())
      }, 300)
    }
  }, [dispatch, message])

  const pageOptions = {
    page: currentPage,
    sizePerPage: sizePerPage,
    totalSize: pagination ? pagination?.totalItems : auditTicketList?.length || 0,
    custom: true,
    totalPages: pagination ? pagination?.totalPages : 1,
    onPageChange: setCurrentPage,
  }

  useEffect(() => {
    let payload = {
      size: sizePerPage,
      module: auditType.value,
      search: searchKey,
    }
    if (startDate && endDate) {
      payload = {
        ...payload,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
      }
    }
    dispatch(onGetAuditTickets(payload))
  }, [startDate, endDate])

  const handleReset = e => {
    setStartDate(defaultStartDate.format(dateformat.default))
    setEndDate(defaultEndDate.format(dateformat.default))
    setSearchKey("")
    dispatch(
      onGetAuditTickets({
        size: sizePerPage,
        page: 0,
        module: auditType.value,
        startDate: defaultStartDate.format(dateformat.default),
        endDate: defaultEndDate.format(dateformat.default),
        search: "",
      })
    )
  }

  const defaultSorted = [
    {
      dataField: "id", // if dataField is not match to any column you defined, it will be ignored.
      order: "desc", // desc or asc
    },
  ]
  const keyField = "_id"

  let auditTypeOptions = map(AuditTypes, el => {
    return {
      value: el.value,
      label: el.title,
    }
  })

  const setDownloadType = () => {
    const exportPayload = {
      file_type: fileType.value,
      module: auditType.value, search: searchKey, startDate: startDate, endDate: endDate,
    }
    dispatch(getExportAuditTickets(exportPayload))
  }

  const handleExport = fileData => {
    const fileName =
      `audit_tickets_` +
      new Date().getTime() +
      `.${fileType.value.toLowerCase()}`
    const downloadType =
      fileType.value == "csv" || fileType.value == "xlsx"
        ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        : "application/pdf"
    const base64data = `data:${downloadType};base64,${fileData}`
    const downloadLink = document.createElement("a")
    downloadLink.href = base64data
    downloadLink.download = fileName
    downloadLink.click()
    return fileName
  }

  const handleSelectType = e => {
    setFileType(e)
  }

  const fileTypeOptions = [
    {
      label: "PDF",
      value: "pdf",
    },
    {
      label: "CSV",
      value: "csv",
    },
    {
      label: "XLSX",
      value: "xlsx",
    },
  ]

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No Data to Display</p>
  }

  const handleTableChange = () => { }

  return (
    <React.Fragment>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField={keyField}
                columns={spListColumns}
                data={filteredRes || []}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return (
                    <ToolkitProvider
                      keyField={keyField}
                      data={filteredRes || []}
                      columns={spListColumns}                      
                      bootstrap4
                      search
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col sm="3">
                              <Select
                                placeholer={"Select Audit Trail"}
                                name={"auditType"}
                                value={auditType}
                                onChange={e => {
                                  setAuditType(e)
                                  dispatch(
                                    onGetAuditTickets({ module: e.value, page: currentPage, size: sizePerPage, search: searchKey })
                                  )
                                }}
                                options={auditTypeOptions}
                                classNamePrefix="select2-selection"
                              />
                            </Col>
                            <Col sm="2">
                              <input
                                className="form-control"
                                type="date"
                                value={startDate}
                                id="startDate"
                                name="startDate"
                                onChange={e => setStartDate(e.target.value)}
                                onBlur={e => setStartDate(e.target.value)}
                              />
                            </Col>
                            <Col sm="2">
                              <input
                                className="form-control"
                                type="date"
                                value={endDate}
                                id="endDate"
                                name="endDate"
                                onChange={e => setEndDate(e.target.value)}
                                onBlur={e => setEndDate(e.target.value)}
                              />
                              </Col>
                            <Col sm="1">
                              <Button
                                color="primary"
                                className="font-16 btn-block btn btn-primary"
                                onClick={e => {
                                  toolkitProps.searchProps.onSearch("")
                                  setTimeout(() => {
                                    handleReset(e)
                                  }, 200)
                                }}
                              >
                                Reset
                              </Button>
                            </Col>
                            <Col sm="2">
                              <div className="search-box ms-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  {/* <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" /> */}
                                  <input
                                    id="search-bar-0"
                                    type="text"
                                    className="form-control "
                                    placeholder="Search"
                                    value={searchKey}
                                    onChange={e => setSearchKey(e.target.value)}
                                  />

                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col sm="2">
                              <div
                                className="text-sm-end"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <div style={{ width: 100 }} className="me-2">
                                  <Select
                                    placeholer={"Select Type"}
                                    name={"fileType"}
                                    value={fileType}
                                    onChange={e => {
                                      handleSelectType(e)
                                    }}
                                    options={fileTypeOptions}
                                    classNamePrefix="select2-selection me-2"
                                  />
                                </div>
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={setDownloadType}
                                >
                                  {/* <i className="bx bx-upload me-1" /> */}
                                  Export
                                </Button>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  remote
                                  keyField={keyField}
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  defaultSorted={defaultSorted}
                                  classes={
                                    "table align-middle table-nowrap table-hover"
                                  }
                                  bordered={false}
                                  striped={false}
                                  responsive
                                  ref={node}
                                  noDataIndication={emptyDataMessage}
                                  onTableChange={handleTableChange}
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  )
                }}
              </PaginationProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default withRouter(AuditTicketList)
